import { getBaseURL } from '@/utils/util'
const baseURL = getBaseURL('api')

export const getMessageCount = () => window.axios({
  url: baseURL + 'message/viewCount',
  method: 'get'
})

export const getMessageData = data => window.axios({
  url: baseURL + 'message/findAll',
  data,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export const setMessageToRead = id => window.axios({
  method: 'get',
  url: baseURL + 'message/unReadToRead?id=' + id,
})

export const setAllMessageToRead = () => window.axios({
  url: baseURL + 'message/readAll'
})
